import _ = require('underscore');

import { Messages } from '../../../../codegen/Localize';
import { ISubscriptionInfo } from '../../../../ts/models/ISubscriptionInfo';
import { changeSubscriptionsFrequency } from '../../../actions/spaces/SubscriptionsActions';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isAnyItemFlowSubscription } from './IEntityActionHelpers';

export const ChangeSubscriptionsFrequencyEntityAction: IEntityAction<ISubscriptionInfo, {}> = {
  name: EntityActionNames.SubscriptionChangeFrequency,
  translateName: Messages.changeSubscriptionsFrequency_action,
  isVisible: (subscriptions) => !isAnyItemFlowSubscription(subscriptions),
  isClickable: (availableActions: {}, subscriptions: ISubscriptionInfo[]) => {
    return _.any(subscriptions, (subscription) => subscription.canManageSubscription);
  },
  createReduxAction: (subscriptions: ISubscriptionInfo[]) => changeSubscriptionsFrequency(subscriptions)
};
